import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import { SqlServer } from '../../../SqlServer/Model/SqlServerModel';
import { Tenant } from '../../Model/FarmModel';
import { CustomSelect } from '../../../../../Common/Components/Controls/InputControls';

type ReplicaSelectProps = {
  tenant: Tenant;
  replicaServers: SqlServer[];
  isMobile: boolean;
  onChange: (replicas: string[]) => void;
};

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 300,
      width: 250,
    },
  },
};

export const ReplicaSelect = ({
  tenant,
  replicaServers,
  isMobile,
  onChange,
}: ReplicaSelectProps) => {
  if (!tenant.AzureSQLServerName) return null;

  const availableReplicas = replicaServers.filter(
    (server) => server.ServerName !== tenant.AzureSQLServerName,
  );

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const selectedReplicas = event.target.value as string[];
    onChange(selectedReplicas);
  };

  return (
    <FormControl sx={{ width: isMobile ? '100%' : '250px' }}>
      <CustomSelect
        multiple
        value={tenant.Replicas || []}
        onChange={handleChange}
        inputProps={{ 'aria-label': 'Replica selection' }}
        renderValue={(selected: string[]) => (selected as string[]).join(', ')}
        MenuProps={MenuProps}
      >
        {availableReplicas.map((server) => (
          <MenuItem key={server.ServerName} value={server.ServerName}>
            <Checkbox
              checked={(tenant.Replicas || []).includes(server.ServerName)}
            />
            <ListItemText primary={server.ServerName} />
          </MenuItem>
        ))}
      </CustomSelect>
    </FormControl>
  );
};
